var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTache3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 89.55 59.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.69,47.55l-4.67.03L0,34.19c0-.43,1.37-1.8,1.79-1.9.63-.15,2.94-.15,2.85.49l-.41,2.97c-.09.66,1.77,1.63,1.97,1.02l1.09-3.24,1.09-3.25c.26-.79,2.45.98,3.25,1.73l1.83,15.81c-3.78,3.05-5.46,5.52-5.35,11.39-2.61-2.74-3.64-6.06-3.43-11.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.12,4.07c-3.04,1.47-3.94,4.92-2.84,9.25-.18.77-3.78-.02-5.02-1.21-1.15-1.1.08-3.99.99-5.98,2.33-5.08,5.14-6.83,11.09-5.88,3.37.54,5.99,6.2,5.01,9.88l-7.28-.13c-1.32-.02-1.13-3.78-1.94-5.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.13,18.8l-6.11-10.81,6.66.31,3.76-7.34-.18,11.06c-.05,2.76-.12,3.56-4.13,6.78Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTache3);
export default __webpack_public_path__ + "static/media/tache3.2f94349c2f2482138b186cfc18fba2a2.svg";
export { ForwardRef as ReactComponent };